<template>
  <v-container fluid tag="section">
    <material-wizard
      v-model="tab"
      title="Novo Mapa"
      subtitle="Selecione a versão da BDGD e CTMT"
      :available-steps="tabsLiberadas"
      :tabs="tabs"
      class="mx-auto"
      :loading="loading"
      @click:next="next()"
      @click:prev="back()"
    >
      <mapas-sequenciamento-eletrico-wizard-tabs ref="mapaSequenciamentoParametros" @step-observer="updateTabStatus($event)" />
    </material-wizard>
  </v-container>
</template>

<script>
  import MapasSequenciamentoEletricoService from '@/services/MapasSequenciamentoEletricoService';
  import MapasSequenciamentoEletricoWizardTabs from '@/components/perdas-tecnicas/sequenciamento-eletrico/mapas/MapasSequenciamentoEletricoWizardTabs';
  import MaterialWizard from '@/components/base/MaterialWizard';
  import wizardMixins from '@/mixins/wizardMixins';
  import routes from '@/store/modules/routes';

  export default {
    components: {
      MapasSequenciamentoEletricoWizardTabs,
      MaterialWizard
    },
    mixins: [wizardMixins],
    data: () => ({
      tabs: ['Mês dos Dados', 'Parâmetros', 'Confirmação'],
      loading: false
    }),
    methods: {
      save() {
        const data = this.$refs.mapaSequenciamentoParametros.exportData();
        this.loading = true;
        MapasSequenciamentoEletricoService.save(data)
          .then(() => {
            this.$toast.success('Mapa de conectividade salvo com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.replace({
              name: routes.state.appRoutes['MAPAS_CONECTIVIDADE']
            });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar o mapa de conectividade.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
